// Tiny global toast bus (Monday-style). Any action can pop a toast with an optional Undo:
//   toastService.show({ message: 'We successfully deleted 1 item', onUndo: () => restore() })
// A single <Toast/> mounted at the app root subscribes and renders it.
const listeners = new Set()
let seq = 0

export const toastService = {
    show(toast) {
        const payload = { id: ++seq, duration: 4000, actionLabel: 'Undo', ...toast }
        listeners.forEach(fn => fn(payload))
        return payload.id
    },
    subscribe(fn) {
        listeners.add(fn)
        return () => listeners.delete(fn)
    },
}
